var _prices, _prices2, _prices3, _SubscriptionsMeta;
import { SubscriptionDuration, SubscriptionType } from "./enums";
export var SubscriptionsMeta = (_SubscriptionsMeta = {}, _SubscriptionsMeta[SubscriptionType.SOCIAL] = {
    article_number: "",
    prices: (_prices = {}, _prices[SubscriptionDuration.THREE_MONTHS] = 12, _prices[SubscriptionDuration.ONE_YEAR] = 40, _prices)
}, _SubscriptionsMeta[SubscriptionType.NORMAL] = {
    article_number: "",
    prices: (_prices2 = {}, _prices2[SubscriptionDuration.THREE_MONTHS] = 33, _prices2[SubscriptionDuration.ONE_YEAR] = 110, _prices2)
}, _SubscriptionsMeta[SubscriptionType.PLUS] = {
    article_number: "",
    prices: (_prices3 = {}, _prices3[SubscriptionDuration.THREE_MONTHS] = 39, _prices3[SubscriptionDuration.ONE_YEAR] = 130, _prices3)
}, _SubscriptionsMeta[SubscriptionType.SUPPORTER] = {
    article_number: "",
    prices: [300, 325, 350, 375, 400, 450, 500, 550, 600, 650, 700, 750, 800, 850, 900, 950, 1000, 1100, 1200, 1300, 1400, 1500] // TODO: maybe we can use flexible prices here
}, _SubscriptionsMeta);
export var subscriptionPrice = function subscriptionPrice(type, duration) {
    return type === SubscriptionType.SUPPORTER ? SubscriptionsMeta[type].prices[0] : SubscriptionsMeta[type].prices[duration];
};
export var subscriptionPriceString = function subscriptionPriceString(type, duration) {
    return subscriptionPrice(type, duration).toLocaleString("de", {
        minimumFractionDigits: 2
    });
};
export var subscriptionPriceDescription = function subscriptionPriceDescription(type, duration) {
    if (type === SubscriptionType.SUPPORTER)
        return "";
    if (duration === SubscriptionDuration.THREE_MONTHS)
        return subscriptionPriceString(type, duration) + " € für 3 Monate";
    if (duration === SubscriptionDuration.ONE_YEAR)
        return subscriptionPriceString(type, duration) + " € pro Jahr";
};
export var evaluateSubscriptionString = function evaluateSubscriptionString(subscriptionType, duration) {
    switch (subscriptionType) {
        case SubscriptionType.SOCIAL:
            return "Sozial Abo " + (duration == SubscriptionDuration.THREE_MONTHS ? "(3 Monate)" : "(1 Jahr)");
        case SubscriptionType.NORMAL:
            return "Normal Abo " + (duration == SubscriptionDuration.THREE_MONTHS ? "(3 Monate)" : "(1 Jahr)");
        case SubscriptionType.PLUS:
            return "Abo+ " + (duration == SubscriptionDuration.THREE_MONTHS ? "(3 Monate)" : "(1 Jahr)");
        default:
            return "Förderabo";
    }
};
export var mapSubscriptionDurationFromFirebase = function mapSubscriptionDurationFromFirebase(duration) {
    switch (duration) {
        case 0:
            return SubscriptionDuration.THREE_MONTHS;
        case 1:
            return SubscriptionDuration.SIX_MONTHS;
        case 2:
        default:
            return SubscriptionDuration.ONE_YEAR;
    }
};
